import { useContext } from "react";

import ErrorModalContext from "./ErrorModalContext";

export default function useErrorModal() {
  return useContext(ErrorModalContext);
}

export { useErrorModal };
